import { Grid, Paper, Box, Typography, Stack } from "@mui/material";
import OrderCard from "./OrderCard";
import { Order } from "./types";

interface Props {
  title: string;
  items: Order[];
  onAdvance: (order: Order) => void;
  onCancel: (order: Order) => void;
  showActions?: boolean; 
}

export default function KanbanColumn({
  title,
  items,
  onAdvance,
  onCancel,
  showActions = true, 
}: Props) {
  return (
    <Grid item xs={12} md={3}>
      <Paper
        variant="outlined"
        sx={{
          p: 1.5,
          borderRadius: 2,
          borderColor: "#eee",
          bgcolor: "#fafafa",
          height: "100%",
        }}
      >
        <Box mb={1.5}>
          <Typography fontSize={13} fontWeight={600}>
            {title}
          </Typography>
          <Typography fontSize={11} color="text.secondary">
            {items.length} órden(es)
          </Typography>
        </Box>

        <Stack spacing={1.5}>
          {items.map((order) => (
            <OrderCard
              key={order.id}
              order={order}
              onAdvance={onAdvance}
              onCancel={onCancel}
              showActions={showActions}
            />
          ))}
        </Stack>
      </Paper>
    </Grid>
  );
}
